import type { SamplePageId } from '../components/SamplePage'

export type VolumePage = {
  /**
   * Image of the real page (portrait 9:16, 1080×1920).
   * If it's empty, the page is drawn in code from the Volume 1 content.
   */
  src?: string
  /** Fallback id: code-drawn version of the page, used only when there's no src. */
  sample: SamplePageId
  caption: string
  alt: string
}

/** Pages from Volume 1, Day One Ready, in display order. */
export const volumePages: VolumePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/vAYJMGceTNMr3mn6XcUApR/01-fence-card-system.jpg',
    sample: 'fence-card-system',
    caption: 'The Fence Card System: one coach, five event groups at once',
    alt: 'Page 6: The Fence Card System, five color-coded cards on the fence and the coach watching every group',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/urag7Prr19AwQ53MzKCptC/02-improvised-vs-carded.jpg',
    sample: 'formula',
    caption: 'Improvised practice vs. carded practice: what changes for your athletes',
    alt: 'Page 10: side-by-side comparison of a practice without a system and organized groups with fence cards',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cyvuGqN4CP5sZtynaXHwPA/03-station-layout.jpg',
    sample: 'session-118',
    caption: 'Lay out your stations so you can see every group from one spot',
    alt: 'Page 11: top-down track and infield diagram showing where to place sprints, hurdles, jumps, throws and distance',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jhaV4H2tYN3hQ8t7amW9m5/04-session-1-13-full-carded-practice.jpg',
    sample: 'session-113',
    caption: 'Session 1.13: your first full carded practice, every group on its own card',
    alt: 'Page 30: Session 1.13, Day 6, field map with five group cards, coach path, athlete card and Level Dial',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/aEcqahY2pEfQ8SGf7Gy1w7/05-day-one-field-card.jpg',
    sample: 'field-card',
    caption: 'The Day One Field Card: everything on one card for your clipboard',
    alt: 'Page 50: Day One Field Card with checklist, practice formula, easier/harder options and cues',
  },
]
